/*
*
* File JS componente Anchor Menu
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css';
import Swiper, { Pagination } from 'swiper';
Swiper.use([Pagination]);

import smoothScroll from 'js/utilities/smooth-scroll';

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './anchor-menu.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const anchorMenu = () =>
{
    const allAnchorMenu = document.querySelectorAll('.anchor-menu__slider');
    if( !allAnchorMenu.length ) return;

    allAnchorMenu.forEach(anchorMenuItem =>
    {
        const swiperAnchorMenu = new Swiper(anchorMenuItem,
        {
            slidesPerView: 'auto',
            spaceBetween: 20,
            centerInsufficientSlides: true,
            a11y:
            {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                notificationClass: 'swiper-notification'
            },
        });

        smoothScroll();
    });
}

export default anchorMenu;

//--------------------------------------------------------------------//